import type CommonDialog from '@/components/common/dialog/CommonDialog.vue'
import { useTemplateRef } from 'vue'

export const useConfirmDialog = () => {
  const commonDialog = useTemplateRef<InstanceType<typeof CommonDialog>>('commonDialog')
  const openModal = async (): Promise<void> => {
    try {
      await commonDialog.value?.openDialog()
    } catch {}
  }

  return {
    openModal
  }
}
